(function () {
  function getConsentRoot(input) {
    return input.closest('.freilaender-go-express-consent');
  }

  function updateHint(input) {
    const root = getConsentRoot(input);
    if (!root) return;

    const hint = root.querySelector('.consent-inline-hint');
    if (hint) hint.hidden = input.checked;
    input.value = input.checked ? 'ja' : '';
  }

  function persistConsent(input) {
    if (typeof routes === 'undefined' || typeof fetchConfig !== 'function') {
      return Promise.resolve();
    }

    const value = input.checked ? 'ja' : '';
    const body = JSON.stringify({
      attributes: {
        go_express_zustimmung: value,
      },
    });

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) return;

        const root = getConsentRoot(input);
        if (root) root.dataset.persistedValue = value;
      })
      .catch(() => {});
  }

  function needsPersist(input) {
    const root = getConsentRoot(input);
    if (!root) return false;

    const persisted = root.dataset.persistedValue || '';
    const desired = input.checked ? 'ja' : '';
    return persisted !== desired;
  }

  function showToast(input, msg) {
    const root = getConsentRoot(input);
    if (!root) return;

    const toast = document.getElementById(root.dataset.toastId);
    if (!toast) return;

    toast.textContent = msg;
    toast.hidden = false;
    clearTimeout(toast._freilaenderTimer);
    toast._freilaenderTimer = setTimeout(() => {
      toast.hidden = true;
    }, 3000);
  }

  function getConsentForForm(form) {
    return (
      form.querySelector('input[name="attributes[go_express_zustimmung]"]') ||
      document.querySelector(`input[name="attributes[go_express_zustimmung]"][form="${form.id}"]`)
    );
  }

  function initAll() {
    document
      .querySelectorAll('.freilaender-go-express-consent input[name="attributes[go_express_zustimmung]"]')
      .forEach((input) => {
        updateHint(input);

        // Checkbox ist standardmäßig angehakt, das Cart-Attribut aber oft noch leer.
        // Ohne Sync fehlt die Zustimmung in der Bestellung (besonders Mobile /cart und Express-Checkout).
        if (needsPersist(input)) {
          persistConsent(input);
        }
      });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="attributes[go_express_zustimmung]"]')) return;

    event.stopPropagation();
    updateHint(event.target);
    persistConsent(event.target);
  });

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
      if (!checkoutButton) return;

      const formId = checkoutButton.getAttribute('form');
      const form =
        (formId && document.getElementById(formId)) ||
        checkoutButton.closest('form#cart, form#CartDrawer-Form');
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;

      const consent = getConsentForForm(form);
      if (!consent) return;

      if (!consent.checked) {
        showToast(consent, 'Ohne Zustimmung gibt es keine Sendungsverfolgung.');
      }

      if (needsPersist(consent)) {
        event.preventDefault();
        event.stopPropagation();

        persistConsent(consent).finally(() => {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(checkoutButton);
            return;
          }

          // Fallback: checkout-Button-Wert manuell mitschicken
          let checkoutField = form.querySelector('input[type="hidden"][name="checkout"]');
          if (!checkoutField) {
            checkoutField = document.createElement('input');
            checkoutField.type = 'hidden';
            checkoutField.name = 'checkout';
            form.appendChild(checkoutField);
          }
          form.submit();
        });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;

      const consent = getConsentForForm(form);
      if (!consent) return;

      if (!consent.checked) {
        showToast(consent, 'Ohne Zustimmung gibt es keine Sendungsverfolgung.');
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart-drawer:opened', initAll);
})();
